import { MdOutlineDashboard } from "react-icons/md";
import { FaHandshake, FaUsers } from "react-icons/fa";
import { LuMessagesSquare } from "react-icons/lu";
import { FaCodePullRequest, FaRobot } from "react-icons/fa6";
import { GrTransaction } from "react-icons/gr";
import { BiCategoryAlt } from "react-icons/bi";
import { MdOutlineSupport } from "react-icons/md";
import { FaBullseye } from "react-icons/fa";
import { FaBrain } from "react-icons/fa";
import { FaShare } from "react-icons/fa";
import { FaFileAlt } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { FaBox } from "react-icons/fa";
import { FaCog } from "react-icons/fa";
import { FaUserCog } from "react-icons/fa";
import { FiMail, FiList } from "react-icons/fi";
import { FiShoppingBag } from "react-icons/fi";

export const NavCategories = [
  {
    title: "Core",
    items: [
      {
        icon: <MdOutlineDashboard />,
        label: "Dashboard",
        url: "/",
      },
      {
        icon: <FaUsers />,
        label: "Users",
        url: "/users",
      },
      {
        icon: <MdOutlineSupport />,
        label: "Support",
        url: "/chat",
      },
      {
        icon: <GrTransaction />,
        label: "Transactions",
        url: "/adminWallet",
      },
    ],
  },
  {
    title: "Merchandise",
    items: [
      {
        icon: <FaBox />,
        label: "Merchandise Products",
        url: "/merchandiseProducts",
      },
      {
        icon: <FaCodePullRequest />,
        label: "Merchandise Requests",
        url: "/merchandiseRequests",
      },
      {
        icon: <BiCategoryAlt />,
        label: "Merchandise Categories",
        url: "/merchandiseCategories",
      },
      {
        icon: <FiShoppingBag />,
        label: "Merchandise Sales",
        url: "/merchandiseSales",
      },
    ],
  },
  {
    title: "Partnerships",
    items: [
      {
        icon: <FaHandshake />,
        label: "Partnerships",
        url: "/partnership",
      },
      {
        icon: <FaUsers />,
        label: "User Partnerships",
        url: "/user-partnerships",
      },
      {
        icon: <FaBullseye />,
        label: "Opportunity Request",
        url: "/opportunity-request",
      },
    ],
  },
  {
    title: "Business",
    items: [
      {
        icon: <FaShare />,
        label: "Social Accounts",
        url: "/social-media",
      },
    ],
  },
  {
    title: "System",
    items: [
      {
        icon: <LuMessagesSquare />,
        label: "FAQ",
        url: "/faqs",
      },
      {
        icon: <FaFileAlt />,
        label: "Terms",
        url: "/term_and_conditions",
      },
      {
        icon: <FaUser />,
        label: "Profile",
        url: "/setting",
      },
      {
        icon: <FaCog />,
        label: "System Config",
        url: "/config-settings",
      },
      {
        icon: <FiMail />,
        label: "Email Templates",
        url: "/email-templates",
      },
      {
        icon: <FiList />,
        label: "Email Logs",
        url: "/email-logs",
      },
      {
        icon: <FaBrain />,
        label: "Questionnaire",
        url: "/questionnaire",
      },
      {
        icon: <FaUserCog />,
        label: "Admin Management",
        url: "/admin-management",
      },
      {
        icon: <FaRobot />,
        label: "AI Feeding",
        url: "/ai-feeding",
      },
    ],
  },
];

// Legacy export for backward compatibility
export const NavItem = NavCategories.flatMap((category) => category.items);
